import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { LOCATION_CONTROLER_URL } from "api/Service";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useCreateLocation = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");
  const handleNetworkError = useHandleNetworkError(
    "Error while creating location"
  );

  return useMutation({
    mutationFn: async (locationData) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}${LOCATION_CONTROLER_URL}`,
        locationData,
        { headers: { "Content-Type": "application/json" } }
      );

      return response.data;
    },
    onSuccess: async () => {
      toast.success("Location created successfully");
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["locationsAll"] }),
        queryClient.invalidateQueries({ queryKey: ["locationsActive"] }),
      ]);
    },
    onError: handleNetworkError,
  });
};
